import { gql } from '@apollo/client';

export const ADD_OTHER_PHOTOS = gql`
  mutation addOtherPhotos($inputs: [AdditionalPhotoInput!]!) {
    addOtherPhotos(inputs: $inputs) {
      id
    }
  }
`;
